import axios from "axios";
import config from "@/config/constants";

type FetchServiceResult = {
  service: Record<string, unknown> | null;
  sessionCapReached: boolean;
  authExpired: boolean;
};

export const fetchService = async (userId: string, serviceId: string): Promise<FetchServiceResult> => {
  const res = await axios.post(
    config.api_env + "/application/api/u/marketplace/get-service",
    { user_id: userId, service_id: serviceId },
    config.options
  );
  const service = res.data.success && res.data.service ? res.data.service : null;
  return {
    service,
    sessionCapReached: service !== null && service.sessions_available === false,
    authExpired: Boolean(res.data.err && res.data.err.includes("3994")),
  };
};
